<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="120px"
      label-position="right">
      <el-form-item label="所属项目" prop="projectId">
        <el-select v-model="formData.projectId" filterable placeholder="请选择所属项目">
          <el-option :label="item.projectName" :value="item.projectId" v-for="(item, index) of projectList"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入库日期" prop="storageDate">
        <el-date-picker v-model="formData.storageDate" value-format="yyyy-MM-dd" type="date"
          placeholder="请选择入库日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="入库说明" prop="storageExplain">
        <div class="textarea-remark">
          <el-input type="textarea" maxlength="300" :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="formData.storageExplain" placeholder="请输入入库说明"></el-input>
          <span>{{ formData.storageExplain.length }}/300</span>
        </div>
      </el-form-item>
      <el-form-item label="入库物料明细" prop="detailedList">
      </el-form-item>
      <el-button class="mb10" type="primary" @click='onExport'>导入入库材料库</el-button>
      <el-table class="global-table material-table" :data="formData.detailedList">
        <el-table-column prop="materialName" label="物料名称">
          <!-- <template v-slot="{ row, $index }">
            <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.materialName'"
              :rules='rules.materialName'>
              <el-input maxlength="30" v-model="row.materialName" placeholder="请输入" disabled></el-input>
            </el-form-item>
          </template> -->
        </el-table-column>
        <el-table-column prop="specifications" label="规格型号">
          <!-- <template v-slot="{ row, $index }">
            <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.specifications'"
              :rules='rules.specifications'>
              <el-input maxlength="30" v-model="row.specifications" placeholder="请输入" disabled></el-input>
            </el-form-item>
          </template> -->
        </el-table-column>
        <el-table-column label="品牌名称" prop="brand">
          <!-- <template v-slot="{ row }">
            <el-input v-model="row.brand" maxlength="30" placeholder="请输入" disabled />
          </template> -->
        </el-table-column>
        <el-table-column prop="materialTypeName" label="物料分类">
          <!-- <template v-slot="{ row, $index }">
            <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.materialTypeId'"
              :rules='rules.materialTypeId'>
              <el-cascader disabled v-model="row.materialTypeId" :options="materialTypeData"
                :props="{ checkStrictly: true, emitPath: false, children: 'childNode', label: 'materialTypeName', value: 'materialTypeId' }"
                placeholder="请选择" clearable></el-cascader>
            </el-form-item>
          </template> -->
        </el-table-column>
        <el-table-column label="单价（元）" prop="unitPrice" width="200px">
          <template v-slot="{ row, $index }">
            <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.unitPrice'" :rules='rules.unitPrice'>
              <el-input maxlength="30" v-model="row.unitPrice" placeholder="请输入"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="单位" prop="company">
          <!-- <template v-slot="{ row }">
            <el-input v-model="row.company" maxlength="10" placeholder="请输入" disabled />
          </template> -->
        </el-table-column>
        <el-table-column prop="supplierName" label="供应商名称" width="200px">
          <!-- <template v-slot="{ row, $index }">
            <el-form-item :label="row.supplierName" :prop="'detailedList.' + $index + '.supplierId'" :rules='rules.supplierId'>
              <el-select v-model="row.supplierId" placeholder="请选择" clearable disabled>
                <el-option v-for="item in supplierData" :key="item.supplierId" :label="item.supplierName"
                  :value="item.supplierId"></el-option>
              </el-select>
              <span>{{ row }}</span>
            </el-form-item>
          </template> -->
        </el-table-column>
        <el-table-column prop="operationStock">
          <template slot="header">
              <span style="color: #f00;font-size: 14px;margin-right: 4px;">*</span>入库数量
          </template>
          <template v-slot="{ row, $index }">
            <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.operationStock'"
              :rules='rules.operationStock'>
              <el-input maxlength="30" v-model="row.operationStock" placeholder="请输入"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseName">
          <template slot="header">
              <span style="color: #f00;font-size: 14px;margin-right: 4px;">*</span>入库仓库
          </template>
          <template v-slot="{ row, $index }">
            <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.warehouseId'"
              :rules='rules.warehouseId'>
              <el-select v-model="row.warehouseId" placeholder="请选择">
                <el-option v-for="item in warehouseData" :key="item.warehouseId" :label="item.warehouseName"
                  :value="item.warehouseId"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="">
          <template v-slot="{ $index }">
            <el-button class="del-btn" type="text" @click="deleteDetailedList($index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="text" class="mt10" icon="el-icon-plus" @click="addMaterial">新增入库物料</el-button>
      <el-form-item label="入库图片" prop="imgList" class="mt30">
        <div class="imgList">
          <div class="imgBlock" v-for="(item, index) in formData.imgList" :key="index">
            <el-image :src="item.filePrefix + item.fileUrl" :preview-src-list="[item.filePrefix + item.fileUrl]"
              fit="fill">
            </el-image>
            <span></span>
            <i class="el-icon-close" @click="imgRemove(index)"></i>
          </div>
          <UploadFile :accept="'jpeg,jpg,png'" @onSuccess="onSuccess" :slotShow='true'
            v-if="formData.imgList.length < 6">
            <i class="el-icon-plus"></i>
            <p>上传图片</p>
          </UploadFile>
        </div>
        <div class="mt20">(最多六张)</div>
      </el-form-item>
      <el-form-item label="上传文件" prop="fileList">
        <UploadFile listType="text" @onSuccess="onSuccess2" :slotShow='true'
          accept="TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、JPG、PNG、PDF、TIFF、SWF">
          <template>
            <div class="file">
              <template>
                <el-link icon="el-icon-upload" type='primary' :underline="false">{{ formData.fileList.length === 0 ?
                  "点击上传" : '重新上传' }}</el-link>
                <el-tooltip class="item" effect="dark"
                  content="支持文件格式：TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、JPG、PNG、PDF、TIFF、SWF，文件大小不超过10M；" placement="right">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </div>
          </template>
        </UploadFile>
        <el-form-item v-if="formData.fileList.length !== 0">
          {{ formData.fileList[0].fileName }}
        </el-form-item>
      </el-form-item>
      <el-form-item class="mt20">
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
    <ImportData :isShowImport.sync="isShowImport" :projectId="formData.projectId" @onSuccess="onExportResult">
    </ImportData>

    <el-dialog title="物料清单" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
      <el-form class="global-form" inline label-width="100px">
        <el-form-item prop="materialName">
          <el-input v-model="searchForm.materialName" clearable placeholder="请输入物料名称"></el-input>
        </el-form-item>
        <el-form-item prop="materialTypeId">
          <el-cascader v-model="searchForm.materialTypeId" :options="materialTypeData"
            :props="{ checkStrictly: true, emitPath: false, children: 'childNode', label: 'materialTypeName', value: 'materialTypeId' }"
            placeholder="请选择物料分类" clearable></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.supplierId" clearable placeholder="供应商名称">
            <el-option v-for="item in supplierData" :key="item.supplierId" :label="item.supplierName"
              :value="item.supplierId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearchWorkOrder">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="table" @selection-change="selectionLineChangeHandle" class="global-table" reserve-selection=true
        :row-key="getRowKeys" :data="tableData">
        <el-table-column reserve-selection type="selection" :selectable="selectable"></el-table-column>
        <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specifications" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brand" label="品牌名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="company" label="单位" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialTypeName" label="物料分类" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierName" label="供应商名称" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="ctime" label="入库日期" min-width="90" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column prop="stock" label="剩余库存" show-overflow-tooltip></el-table-column> -->
      </el-table>

      <global-pagination @size-change="getMaterialData" @current-change="getMaterialData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </el-dialog>
  </el-card>
</template>

<script>
import UploadFile from '@/components/uploadFile/Index.vue'
import ImportData from './export.vue'
const operationStockV = (rule, value, callback) => {
  const reg = /^[1-9][0-9]*$/
  if (!reg.test(value) || Number(value) > 9999999) {
    return callback(new Error('请输入1到9999999整数'))
  } else {
    return callback()
  }
}
const unitPriceV = (rule, value, callback) => {
  if ((value && !Number(value)) || (value && (value > 9999999.9 || value < 0.1))) {
    return callback(new Error('单价为0.1到9999999.9的数字'))
  } else {
    return callback()
  }
}
export default {
  name: 'WarehousingAdd',
  components: {
    UploadFile,
    ImportData
  },
  props: {},
  data() {
    return {
      formData: {
        projectId: '',
        storageDate: '',
        storageExplain: '',
        imgList: [],
        fileList: [],
        detailedList: []
      },
      dialogVisible: false, // 物料清单
      searchForm: { // 物料清单
        materialName: '', // 产品名称
        materialTypeId: '', // 物料分类
        supplierId: '' // 供应商
      },
      tableData: [], // 物料清单
      page: 1,
      size: 10,
      total: 0,
      selectItems: [], // 临时选中的物料
      isShowImport: false,
      materialTypeData: [], // 物料类型
      warehouseData: [], // 仓库列表
      supplierData: [], // 供应商类型
      loading: false,
      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'blur' }
        ],
        storageDate: [
          { required: true, message: '请选择入库日期', trigger: 'blur' }
        ],
        detailedList: [
          { required: true, message: '请添加入库物料明细', trigger: 'change' }
        ],
        materialName: [
          { required: true, message: '请输入产品名称', trigger: 'change' }
        ],
        specifications: [
          { required: true, message: '请输入规格型号', trigger: 'change' }
        ],
        materialTypeId: [
          { required: true, message: '请选择物料分类', trigger: 'change' }
        ],
        // supplierId: [
        //   { required: true, message: '请输入供应商名称', trigger: 'change' }
        // ],
        operationStock: [
          { required: true, message: '请输入入库数量', trigger: 'change' },
          { validator: operationStockV, trigger: ['blur', 'change'] }
        ],
        warehouseId: [
          { required: true, message: '请选择入库仓库', trigger: 'change' }
        ],
        unitPrice: [
          { validator: unitPriceV, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
    'formData.projectId'() {
      // 清空所有行的仓库ID
      this.formData.detailedList.forEach((item) => {
        item.warehouseId = ''
      });

      // 手动清除仓库字段的验证状态
      this.$nextTick(() => {
        this.formData.detailedList.forEach((_, index) => {
          this.$refs.form.clearValidate(`detailedList.${index}.warehouseId`);
        });
      });

      // 获取新项目的仓库列表
      this.$axios.get(this.$apis.material.selectYhWarehouseByList, {
        projectId: this.formData.projectId
      }).then(res => {
        this.warehouseData = res.list;
      });
    }
  },
  created() {
    this.loadMaterialType() // 物料类型
    this.loadSupplierType() // 加载供应商
  },
  methods: {
    // 物料类型
    loadMaterialType() {
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByList).then(res => {
        this.materialTypeData = res || []
      })
    },
    // 加载供应商
    loadSupplierType() {
      this.$axios.get(this.$apis.material.selectYhSupplierByPage).then(res => {
        this.supplierData = res.list
      })
    },
    // 导入数据加入表格中
    onExportResult(data) {
      console.log('添加', data)
      const successList = data.data.successList.map((item) => {
        return {
          materialTypeId: item.materialTypeId,
          materialTypeName: item.materialTypeName,
          materialId: item.materialId,
          materialName: item.materialName,
          specifications: item.specifications,
          brand: item.brand,
          company: item.company,
          unitPrice: item.unitPrice,
          supplierId: item.supplierId,
          supplierName: item.supplierName,
          operationStock: item.operationStock,
          warehouseId: item.warehouseId
        }
      }) || []
      this.formData.detailedList.push(...successList)
      this.$nextTick(() => {
        this.$refs.form.validateField('detailedList'); // 手动触发验证
      });
      console.log('successList', this.formData);
    },
    addMaterial() {
      if (!this.formData.projectId) {
        this.$message.warning('请先选择项目')
        return
      } else {
        this.page = 1
        this.searchForm = { // 物料清单
          materialName: '', // 产品名称
          materialTypeId: '', // 物料分类
          supplierId: '' // 供应商
        }
        this.getMaterialData()
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.table.clearSelection()
          this.formData.detailedList.forEach(item => {
            this.$refs.table.toggleRowSelection(item, true)
          })
        })
      }
      // this.formData.detailedList.push({
      //   materialTypeId: '', // 分类id
      //   materialName: '', // 物料名称
      //   specifications: '', // 规格
      //   brand: '', // 品牌
      //   unitPrice: '', // 单价
      //   company: '', // 单位
      //   supplierId: '', // 供应商ID
      //   operationStock: '', // 入库数量
      //   warehouseId: '' // 仓库ID
      // })
    },
    // 获取物料
    getMaterialData() {
      this.$axios.get(this.$apis.material.selectYhMaterialInfoByPage, {
        ...this.searchForm,
        page: this.page,
        size: this.size,
        isStop: 0 // 启用的
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      })
    },
    selectionLineChangeHandle(val) {
      this.selectItems = val
    },
    // 记录选择的物料，翻页不影响
    getRowKeys(row) {
      return row.materialId
    },
    // 勾选物料
    confirm() {
      let arr = []
      arr = this.selectItems.filter((item) => {
        return this.formData.detailedList.every((k) => {
          return item.materialId !== k.materialId
        })
      })
      this.formData.detailedList = [...this.formData.detailedList, ...arr]
      this.dialogVisible = false
    },
    // 分页
    onSearchWorkOrder() {
      this.page = 1
      this.getMaterialData()
    },
    selectable(row) {
      return !this.formData.detailedList.some((item) => item.materialId === row.materialId)
    },

    deleteDetailedList(index) {
      this.formData.detailedList.splice(index, 1)
    },
    // 图片成功返回
    onSuccess(file) {
      (this.formData.imgList).push(file)
    },
    imgRemove(index) {
      this.formData.imgList.splice(index, 1)
    },
    // 文件上传
    onSuccess2(file) {
      this.formData.fileList = [file]
    },
    onExport() {
      if (!this.formData.projectId) {
        this.$message.warning('请先选择项目')
        return
      }
      this.isShowImport = true
    },
    submit() {
      console.log(111);

      (this.$refs.form).validate((valid) => {
        if (valid) {
          console.log(2222);
          const formData = JSON.parse(JSON.stringify(this.formData))
          formData.detailedList.forEach((item) => {
            delete item.isDel
            delete item.isStop
            delete item.utime
            delete item.stock
          })
          console.log('formData', formData);

          this.$axios.post(this.$apis.material.insertYhStorage, formData).then(() => {
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.global-form2 {
  ::v-deep .material-table {

    .el-input,
    .el-select,
    .el-cascader {
      width: 100% !important;
    }

    .el-form-item {
      margin-bottom: 0
    }

    ;

    .el-form-item--small.el-form-item {
      margin-bottom: 0
    }

    .cell {
      height: 62px;
      display: flex;
      align-items: center
    }
  }
}

.el-textarea {
  width: 380px;
}

.textarea-remark {
  width: 380px;
  position: relative;

  span {
    position: absolute;
    right: 10px;
    bottom: 0px;
    font-size: 12px;
    color: #bbb;
  }
}

.imgList {
  width: 100%;
  min-height: 104px;
  display: flex;
  margin-top: 15px;
  flex-wrap: wrap;

  .imgListTitle {
    margin-right: 10px;
  }

  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin: 0 10px 10px 0 !important;

    .el-image,
    img,
    video {
      width: 100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    i:hover {
      color: #ffffff98;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding: 25px 10px;

    i {
      font-size: 22px;
      color: #999;
      margin-bottom: 7px;
    }
  }

  ::v-deep .el-upload {
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
  }
}
</style>
